export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Получатель: "])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пользователь не найден"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Контакты"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подробнее"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выбор пользователей"])}
}